import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import { getContract } from "../utils/contract";
import { BIFROST_CONTRACT } from "../utils/constants";
import bifrostAbi from "../assets/abis/bifrostnew.json";


export const useBifrostContract = () => {
    const web3context = useSelector((state) => state.web3.web3context);
    const ethereum = web3context?.library;
  
    return [
      ethereum,
      useMemo(
        () => getContract(bifrostAbi, BIFROST_CONTRACT, ethereum),
        [ethereum]
      ),
    ];
  };


export const useCashOutReward = (tier, name) => {
    const web3context = useSelector((state) => state.web3.web3context);
    const [provider, contract] = useBifrostContract();
    const account = web3context?.account;
    
    const cashOutReward = async (contract, createdAt) => {
      if (!provider || !account) {
        return;
      }
      if (createdAt) {        
        return contract.methods
          .claimReward(Number(createdAt), name, tier)
          .send({ from: account });
      }
  
      if (tier) {
        return contract.methods.cashoutAll(tier).send({ from: account });
      }
      
      return contract.methods.claimRewardAll().send({ from: account });
    };
  
    const { isLoading, mutateAsync } = useMutation(
      ([createdAt]) => cashOutReward(contract, createdAt)
    );
  
    return { cashOutReward: mutateAsync, isLoading };
};


export const useGetNodeNumber = (tier) => {
  const [provider, contract] = useBifrostContract();
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;
  
  async function getNodeNumber() {
    try {
      if (tier) {
        return contract.methods.getNodeNumberOf(account, tier).call();
      }

      return contract.methods.getNodeNumberOf(account).call();
    } catch (e) {
      console.log(e);
      return 0;
    }
  }

  return useQuery(["nodeNumber", tier, Boolean(provider)], getNodeNumber, {
    enabled: Boolean(account && provider),
  });
};


export const useGetTotalRewards = (
  tier,
  numberOfNodes = 0
) => {
  const [provider, contract] = useBifrostContract();
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;

  async function getTotalRewards() {
    try {
      if (tier) {
        return contract.methods.getRewardAmountOf(account, tier).call();
      }

      return contract.methods.getRewardAmountOf(account).call();
    } catch (e) {
      return Promise.resolve(0);
    }
  }

  return useQuery(
    ["totalRewards", account, tier, numberOfNodes, Boolean(provider)],
    getTotalRewards,
    {
      refetchInterval: 5000,
      enabled: Boolean(account && provider),
      cacheTime: 0,
    }
  );
};